import CoverageMap from "@/components/CoverageMap";

export default function CoveragePage() {
  return (
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
      <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">
        Coverage footprint
      </div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-semibold mt-3 max-w-3xl">
        Where we operate.
      </h1>
      <p className="mt-6 text-slate-600 max-w-2xl leading-relaxed">
        Regional crew hubs and vetted subcontractor networks cover all 88
        counties across New Jersey and Pennsylvania. Emergency and boarding
        services are dispatched within 24 hours in every listed region.
      </p>
      <div className="mt-12">
        <CoverageMap />
      </div>
    </div>
  );
}
